import React, {ReactNode} from 'react';
import {Button, CircularProgress, Stack, Typography} from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import {useTranslation} from "react-i18next";
import {useAccountStyle} from "@containers/accountStyle/hooks/useAccountStyle";

interface IProps {
	text: ReactNode,
	pending: boolean,
	onCancel: () => void,
	onConfirm: () => void,
}

/** The last step of the switcher: a pick only marks the row, the switch waits for this button. */
const SwitchConfirmBar = ({text, pending, onCancel, onConfirm}: IProps) => {

	const {t} = useTranslation()
	const {tokens} = useAccountStyle()

	return (
		<Stack
			direction={'row'}
			alignItems={'center'}
			gap={1.5}
			sx={{px: 3, py: 1.5, borderTop: 1, borderColor: 'divider', bgcolor: 'background.paper'}}
		>
			<Typography sx={{flex: 1, minWidth: 0, fontSize: 14, fontWeight: 600, lineHeight: 1.4, overflowWrap: 'anywhere'}}>
				{text}
			</Typography>
			<Button onClick={onCancel} disabled={pending} sx={{textTransform: 'none', flexShrink: 0}}>
				{t('adminAccounts.cancel')}
			</Button>
			<Button
				variant={'contained'}
				disableElevation
				autoFocus
				disabled={pending}
				startIcon={pending ? <CircularProgress size={16} color={'inherit'}/> : <LoginIcon/>}
				onClick={onConfirm}
				sx={{textTransform: 'none', fontWeight: 600, flexShrink: 0, bgcolor: tokens.accent, color: '#fff', '&:hover': {bgcolor: tokens.accent, filter: 'brightness(0.92)'}}}
			>
				{t('adminAccounts.switcherGo')}
			</Button>
		</Stack>
	);
};

export default SwitchConfirmBar;
